export const PREVIOUS_CALLID_STORAGE_KEY = 'ci-SAT';
export  const DEFAULT_API_REQUEST_RETRIES = 10
export  const DEFAULT_API_REQUEST_RETRIES_DELAY = 300
export  const DEFAULT_API_REQUEST_RETRIES_DELAY_INCREMENT  = 100